var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitStep4Light(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_4372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 33.1797,
    fill: "#FF6B35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 85,
    width: 135,
    height: 14,
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1211 128H70.4411L76.5211 98.74H10.7811L14.0111 82.97L95.9011 -5.00001H112.431L93.2411 85.63H110.341L107.491 98.74H90.3911L84.1211 128ZM94.1911 13.81L27.6911 85.63H79.3711L94.5711 13.81H94.1911Z",
    fill: "#FFFAF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_4372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 33.18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitStep4Light);
export default __webpack_public_path__ + "static/media/digit_step_4_light.11ad88ee9ab7b7fd3944794932239caf.svg";
export { ForwardRef as ReactComponent };